import type { FaireProductEntity } from "../../entity_types/product";

export const p_2y3cw3aepb: FaireProductEntity = {
  token: "p_2y3cw3aepb",
  type: "product",
  name: "T3535 Relaxed Sherpa Striped Half Zip Pullover",
  brandToken: "b_3s5yghx62g",
  brandName: "Creamon",
  imageUrl:
    "https://cdn.faire.com/fastly/70b3954717d051647df604c996fab1d3507d08c691a9ed21ee5e8bd56b1d5ea8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/54eda449a79c0045e872d91131c1e3bdcaa2d8d78c7bf8049bebaded8c4979d2.jpeg",
    "https://cdn.faire.com/fastly/d4f8594a662ab3080a47d07c849675313ea3f1233d1920bd00dda408ba866ab0.jpeg",
    "https://cdn.faire.com/fastly/03dbffd9a853e5d924b5da37f8a14960ba9240ffb4b529793ba4c4b32a98aade.jpeg",
    "https://cdn.faire.com/fastly/a6e775b8de860619071daf9c91407c46ccfcb6888fe59e7848d70f674bdeae47.jpeg",
    "https://cdn.faire.com/fastly/3ce8ede16544e8b855f7c0afd6bf1d9f35726511ee376330f76330fc36ec6a52.jpeg",
    "https://cdn.faire.com/fastly/0eb83b19ad42e9781b41ea352f2161f6b959f8d8878be71e5765438fc0f1b855.jpeg",
    "https://cdn.faire.com/fastly/1c5f7230da7fbd6f0ee9b8a339d1564f61b572c5df7f9f6d981f782abbcad0bb.jpeg",
    "https://cdn.faire.com/fastly/e2e07e02d86db59ca8ddf533171114302b6c50df58fbfd9594c47b95d30a7e6a.jpeg",
    "https://cdn.faire.com/fastly/03d17783c98be141cbadde00a5350621b5c78daa505827fcbc9098346a9d24f5.jpeg",
    "https://cdn.faire.com/fastly/9838e8026b57907532e3ec8aa8d056888216bd021a372b1b26f61d39ca4747c2.jpeg",
    "https://cdn.faire.com/fastly/dc806157ec4be7cb3a25f5da9e6c5452e95137c431fa9336a0a9afba6753c260.jpeg",
    "https://cdn.faire.com/fastly/7267ec598a346e96d4e88129893ebd63e8b2d97f0ad2b4c878b990d623662441.jpeg",
  ],
  priceDollars: 29,
  description:
    "Coastal Stripe Sherpa Half Zip Pullover\n\nA cozy striped sherpa pullover designed with soft textured fleece and an oversized silhouette for the perfect relaxed cold weather look.\n\nFabric and Fit\nCrafted from an ultra soft sherpa fleece fabric with a plush textured feel and cozy warmth. Designed in an oversized relaxed silhouette with dropped shoulders and voluminous sleeves for a comfortable effortless fit. The adjustable hem detail allows for versatile styling while maintaining a casual laid back shape.\n\nKey design features\nSoft sherpa fleece texture\nAllover contrast stripe pattern\nHalf zip high neckline\nOversized dropped shoulder silhouette\nAdjustable drawstring hem\nVoluminous relaxed sleeves\nCozy lightweight feel\n\nRecommended Use\nPerfect for casual everyday wear cozy weekends travel days and layered cold weather styling\n\nExtra Info\nSELF:100%POLYESTER\nLINING:100%RAYON\nMade in China",
  tags: [],
  msrpDollars: 58,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-18T16:14:51.490Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
